<mat-card>
  <mat-card-content>
    <form [formGroup]="createProfileForm" (ngSubmit)="create_profile()">
      <mat-form-field appearance="fill">
        <mat-label>What's your name</mat-label>
        <input matInput required formControlName="displayName">
      </mat-form-field>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>What do you study currently?</mat-label>
        <input matInput required formControlName="currently_studying">
        <mat-hint>E.g : BTech Mechanical Engineering</mat-hint>
      </mat-form-field>
      <br>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>What do you want to study?</mat-label>
        <input matInput required formControlName="want_to_study">
        <mat-hint>E.g : MTech Mechanical Engineering</mat-hint>
      </mat-form-field>
      <br>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>When do you want to study in germany?</mat-label>
        <input matInput required formControlName="when_to_study">
        <mat-hint>E.g : Feb 2022</mat-hint>
      </mat-form-field>
      <br>
      <br>
      <mat-form-field appearance="fill">
        <mat-label>Whats your whatsapp number?</mat-label>
        <input matInput required formControlName="phoneNumber" type="tel">
      </mat-form-field>
      <br>
      <br>
      <button mat-flat-button color="primary" [disabled]="!createProfileForm.valid" type="submit">Create Profile</button>
    </form>
  </mat-card-content>
</mat-card>
